import React, { Component } from 'react';
import HeaderFreebies from '../../assets/images/freebies/__header.png';
import IllustrationAbstractFont from '../../assets/images/freebies/__illustrationAbstractFont.png';
import IllustrationBogasFont from '../../assets/images/freebies/__illustrationBogasFont.png';
import IllustrationRacetrisFont from '../../assets/images/freebies/__illustrationRacetrisFont.png';
import IllustrationDropRacingIcons from '../../assets/images/freebies/__illustrationDropRacingIcons.png';
import IllustrationPexels from '../../assets/images/freebies/__illustrationPexels.png';
import ProjectHeader from '../ProjectHeader';

import ZipAbstractFont from '../../downloads/AbstractDropFont.zip';
import ZipBogasFont from '../../downloads/BogasFont.zip';
import ZipRacetrisFont from '../../downloads/RacetrisFont.zip';
import ZipDropRacingIcons from '../../downloads/DropRacingIcons.zip';

class ProjectFreebies extends Component {
	render() {
		return (
			<div className="publish-container__wrapper">
				<ProjectHeader />
				<h1 className="title-h1 bold">Freebies</h1>
				<span className="title-caption step-4">Download icons, fonts and photos</span>
				<div className="publish-container">
					<img src={HeaderFreebies} alt="Caption for single" />
					<p>
						In here you can find a collection of assets I made as a hobby or for several projects, that you can download for personal use.
					</p>

					<h3>Bogas Font</h3>
					<p>
						A simple, bold font, of the basic latin alphabet, with and an alternate version of each letter.<br></br>
						Download {' '}
						<a download="BogasFont.zip" href={ZipBogasFont} target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" target="_blank" download="BogasFont.zip" href={ZipBogasFont}>
						<img to="/" src={IllustrationBogasFont} alt="Bogas Font illustration" />
					</a>
					<br />

					<h3>Abstract Drop Font</h3>
					<p>
						One font made of abstract shapes, symbols and numbers.<br></br>
						Download {' '}
						<a download="AbstractDropFont.zip" href={ZipAbstractFont} target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" target="_blank" download="AbstractDropFont.zip" href={ZipAbstractFont}>
						<img to="/" src={IllustrationAbstractFont} alt="Abstract Drop Font illustration" />
					</a>
					<br />

					<h3>Racetris Font</h3>
					<p>
						A font with the pieces (also known as tetrominoes) of famous Tetris game (and the less famous Drop Racing).<br></br>
						Download {' '}
						<a download="RacetrisFont.zip" href={ZipRacetrisFont} target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" target="_blank" download="RacetrisFont.zip" href={ZipRacetrisFont}>
						<img to="/" src={IllustrationRacetrisFont} alt="Racetris Font illustration" />
					</a>
					<br />

					<h3>Photos on Pexels</h3>
					<p>
						A collections of photos I took, free to use.<br></br>
						Check them {' '}
						<a href="https://www.pexels.com/@miguel-santos-179259/gallery/" target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" target="_blank" href="https://www.pexels.com/@miguel-santos-179259/gallery/">
						<img to="/" src={IllustrationPexels} alt="Pexels photos illustration" />
					</a>
					<br />

					<h3>Drop Racing Icons</h3>
					<p>
						Icon set, with 20 icons, created to use on the Drop Racing game.<br></br>
						Download {' '}
						<a download="DropRacingIcons.zip" href={ZipDropRacingIcons} target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" target="_blank" download="DropRacingIcons.zip" href={ZipDropRacingIcons}>
						<img to="/" src={IllustrationDropRacingIcons} alt="Drop Racing Icons illustration" />
					</a>
					<br />

					<p>Thank you.</p>
				</div>
			</div>
		);
	}
}

export default ProjectFreebies;
